module.exports = __webpack_public_path__ + "static/media/10.8d27a4db.png";